import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength: number): string {
    if (!value || value.trim().length === 0) {
      return ''; // Se la stringa è vuota, nulla o indefinita, restituisci una stringa vuota
    }

    if (value.length <= maxLength) {
      return value; // Se la stringa è più corta del limite, restituiscila com'è
    }

    const truncated = value.slice(0, maxLength); // Taglia al massimo consentito
    const lastSpaceIndex = truncated.lastIndexOf(' '); // Trova l'ultimo spazio

    return lastSpaceIndex === -1
      ? truncated + '...' // Se non ci sono spazi, aggiungi "..."
      : truncated.slice(0, lastSpaceIndex) + '...'; // Tronca all'ultimo spazio
  }
}
